import Page from '@admin/components/page'
import Overview from './overview'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.design.title,
  manager: {
    path: `/admin/truevail/agency/designs/${resources.design.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview design={ resources.design } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  design: `/api/admin/truevail/agency/designs/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
